// Função para calcular idade dinamicamente
const calcularIdade = () => {
  const dataNascimento = new Date("1990-06-10");
  const hoje = new Date();
  let idade = hoje.getFullYear() - dataNascimento.getFullYear();
  const mes = hoje.getMonth() - dataNascimento.getMonth();

  if (mes < 0 || (mes === 0 && hoje.getDate() < dataNascimento.getDate())) {
    idade--;
  }

  return idade;
};

const translations = {
  en: {
    // Header
    title: "MARCELOATJ   |   WEB, MOBILE & DESKTOP DEVELOPER   |   FULL STACK DEVELOPER",

    // About Section
    about: "About Me",
    fullName: "Marcelo Assunção Tannús Júnior",
    degree: "Computer Science",
    aboutText1: `I am Marcelo Assunção Tannús Júnior, a Full-Stack Developer, ${calcularIdade()} years old, currently working as a Development Analyst at Arcus Tecnologia. Technology and innovation motivate me to deliver robust, high-quality solutions. I have experience in developing cross-platform applications with Flutter (web, mobile, and desktop), as well as developing APIs with Python, Node.js, and Java.`,
    aboutText2: "At Arcus Tecnologia, I am responsible for maintaining and developing technological solutions that directly impact the company's results. I have experience with several SQL databases (such as PostgreSQL, SQL Server, Oracle, Firebird, and MySQL), as well as in hosting applications and configuring servers on DigitalOcean, using Cloudflare and proxies to ensure the performance and security of our applications.",
    aboutText3: "I am in the final semester of my Computer Science degree at Unitri in Uberlândia-MG, originally from Campina Verde-MG, and currently residing in Uberlândia-MG. Throughout my professional career, I have always sought to study and stay up-to-date with the latest technologies to ensure that my deliveries are not only functional but also innovative.",
    aboutText4: "I have strong teamwork skills, good communication, and am fluent in Portuguese, with intermediate English. My focus has always been on commitment and meeting deadlines, which has always distinguished me in all my projects. Additionally, in my free time, I enjoy exercising, such as walking, running, and working out, maintaining a balance between my personal and professional life.",
    aboutText5: "My differential? I always dedicate myself to the fullest to learn, grow, and deliver the best possible in every task. I am confident that I can positively contribute to the company with my effort and dedication.",

    // Skills Section
    skills: "Skills",
    technicalSkills: "Technical Skills",
    // Interpersonal Skills
    interpersonalSkills: "Interpersonal Skills",
    teamWork: "Teamwork",
    communication: "Communication",
    leadership: "Leadership",
    creativeThinking: "Creative Thinking",
    researchSkills: "Research Skills",
    creativity: "Creativity",
    adaptability: "Adaptability",
    problemSolving: "Problem Solving",
    decisionMaking: "Decision Making",

    languages: "Languages",
    Brasil: "Portuguese",
    EUA: "English",
    Espanha: "Spanish",

    // Experience Section
    experience: "Experience",
    currentJob: "Arcus Tecnologia Ltda",
    jobPeriod: "2019 - Present",
    experienceText1: "As a Full Stack Developer at Arcus Tecnologia, I am responsible for the creation, development, and maintenance of innovative technological solutions, primarily focused on process optimization and the delivery of scalable solutions. In a small-sized company, my role spans multiple areas of development, with a greater focus on cross-platform applications and system integration, always aiming to improve operational efficiency.",

    experienceText2: "Development of mobile and web applications using Flutter, Java, Python, and other relevant technologies.",
    experienceText3: "Integration of RESTful APIs to ensure efficient communication between systems and platforms.",
    experienceText4: "Management of relational databases, with experience in Oracle, SQL Server, PostgreSQL, Firebird, and MySQL, ensuring the performance and scalability of solutions.",
    experienceText5: "Active participation in all stages of the development cycle: from planning, prototyping, and design to implementation and post-launch maintenance.",
    experienceText6: "Close collaboration with design and product teams, ensuring that solutions meet user needs and align with business objectives.",
    experienceText7: "Server management on DigitalOcean, including configuration, maintenance, and deployment of applications on dedicated servers.",
    experienceText8: "Configuration and maintenance of infrastructure on Cloudflare, including proxy implementation and network security.",
    experienceText9: "Publishing applications on app stores such as Google Play Store and Apple App Store, ensuring a smooth and efficient launch process.",


    // Footer
    footerMessage: "MARCELOATJ. All rights reserved.",
  },

  pt: {
    // Header
    title: "MARCELOATJ   |   DESENVOLVEDOR WEB, MOBILE & DESKTOP   |   FULL STACK DEVELOPER",

    // About Section
    about: "Sobre Mim",
    fullName: "Marcelo Assunção Tannús Júnior",
    degree: "Ciência da Computação",
    aboutText1: `Sou Marcelo Assunção Tannús Júnior, um Desenvolvedor Full-Stack com ${calcularIdade()} anos, atualmente atuando como Analista de Desenvolvimento na Arcus Tecnologia. 
    A tecnologia e inovação me motiva a entregar soluções robustas e de alta qualidade. Tenho experiência no desenvolvimento 
    de aplicações multiplataforma com Flutter, web, mobile e desktop, além de desenvolver APIs com Python, Node.js e Java.`,
    aboutText2: `Na Arcus Tecnologia, sou responsável pela manutenção e criação de soluções tecnológicas que impactam diretamente os resultados da empresa. 
    Tenho experiência com diversos bancos de dados SQL (como PostgreSQL, SQL Server, Oracle, Firebird e MySQL), bem como em hospedagem de aplicações e configurações de servidores na DigitalOcean, 
    utilizando Cloudflare e proxys para garantir a performance e a segurança das nossas aplicações.`,
    aboutText3: `Estou no último período em Ciência da Computação pela Unitri em Uberlândia-MG, sou natural de Campina Verde-MG e residente em Uberlândia-MG. 
    Ao longo da minha trajetória profissional, sempre busquei estudar e me manter atualizado das tecnologias que vêm aparecendo no mercado, para garantir que minhas entregas sejam não apenas funcionais, mas também inovadoras.`,
    aboutText4: `Tenho uma forte facilidade de trabalho em equipe, boa comunicação e sou fluente em Português, com inglês intermediário. 
    Meu foco sempre foi no comprometimento e entregas dentro do prazo, algo que sempre me distingue em todos os meus projetos. 
    Além disso, no meu tempo livre, gosto de praticar exercícios como caminhadas, corridas e academia, mantendo o equilíbrio entre minha vida pessoal e profissional.`,
    aboutText5: `Meu diferencial? Sempre me dedico ao máximo para aprender, crescer e entregar o melhor possível em cada tarefa. 
    Tenho a garantia de que posso contribuir positivamente para a empresa com meu esforço e dedicação.`,

    // Skills Section
    skills: "Habilidades",
    technicalSkills: "Habilidades Técnicas",
    // Habilidades Interpessoais
    interpersonalSkills: "Habilidades Interpessoais",
    teamWork: "Trabalho em Equipe",
    communication: "Comunicação",
    leadership: "Liderança",
    creativeThinking: "Pensamento Criativo",
    researchSkills: "Habilidade de Pesquisa",
    creativity: "Criatividade",
    adaptability: "Adaptação",
    problemSolving: "Resolução de Problemas",
    decisionMaking: "Tomada de Decisão",

    languages: "Idiomas",
    Brasil: "Português",
    EUA: "Inglês",
    Espanha: "Espanhol",

    // Experience Section
    experience: "Experiência",
    currentJob: "Arcus Tecnologia Ltda",
    jobPeriod: "2019 - Presente",
    experienceText1: "Atuando como Desenvolvedor Full Stack na Arcus Tecnologia, sou responsável pela criação, desenvolvimento e manutenção de soluções tecnológicas inovadoras, voltadas principalmente para otimização de processos e entrega de soluções escaláveis. Em uma empresa de porte pequeno, minha atuação abrange diversas áreas do desenvolvimento, com um foco maior em aplicações multiplataforma e integração de sistemas, sempre com o objetivo de melhorar a eficiência operacional.",
    
    experienceText2: "Desenvolvimento de aplicações móveis e web utilizando Flutter, Java, Python e outras tecnologias relevantes.",
    experienceText3: "Integração de APIs RESTful para garantir comunicação eficiente entre sistemas e plataformas.",
    experienceText4: "Gestão de bancos de dados relacionais, com experiência em Oracle, SQL Server, PostgreSQL, Firebird e MySQL, para garantir o desempenho e a escalabilidade das soluções.",
    experienceText5: "Participação ativa em todas as fases do ciclo de desenvolvimento: desde o planejamento, prototipagem e design até a implementação e manutenção pós-lançamento.",
    experienceText6: "Colaboração estreita com equipes de design e produto, garantindo que as soluções atendam às necessidades dos usuários e estejam alinhadas com os objetivos de negócios.",
    experienceText7: "Gerenciamento de servidores na DigitalOcean, incluindo a configuração, manutenção e implementação de aplicativos em servidores dedicados.",
    experienceText8: "Configuração e manutenção de infraestrutura em Cloudflare, incluindo a implementação de proxies e segurança de redes.",
    experienceText9: "Publicação de aplicativos nas lojas de aplicativos, como Google Play Store e Apple App Store, garantindo que o processo de lançamento seja eficiente e sem falhas.",

    // Footer
    footerMessage: "MARCELOATJ. Todos os direitos reservados.",
  },
};

export default translations;
